

















































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";
import Logs from "./logs.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Logs,
    Edit
  }
})
export default class extends Mixins(MyList) {
  logsModalVisible = false;

  dispatchType = "invitecode/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "申请时间", dataIndex: "created_time" },
    { title: "申请人", dataIndex: "name" },
    { title: "场馆名称", dataIndex: "stadium_name" },
    { title: "订场电话", dataIndex: "stadium_phone" },
    { title: "性别", scopedSlots: { customRender: "sex" } },
    { title: "省市区", scopedSlots: { customRender: "area" } },
    { title: "地址", dataIndex: "addr" },
    { title: "联系人", dataIndex: "guard" },
    { title: "电话", dataIndex: "phone" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "类型", scopedSlots: { customRender: "stadium_id" } },
    { title: "是否邀请", scopedSlots: { customRender: "is_invite" } },
    { title: "备注", scopedSlots: { customRender: "remark" } },
    { title: "操作", scopedSlots: { customRender: "action" }, width: 200 }
  ];

  mounted() {
    this.loadData();
  }

  sendCode(id: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定发送邀请码吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("invitecode/send", {
          id
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("发送成功");
          this.loadData();
        } else {
          this.$message.error("发送失败");
        }
      }
    });
  }

  showLogsModal(id: number) {
    this.editId = id;
    this.logsModalVisible = true;
  }

  hideLogsModal() {
    this.logsModalVisible = false;
  }
}
